import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { BufferedSourceJsonReader1eguw7qhrwt7p as BufferedSourceJsonReader } from './BufferedSourceJsonReader.mjs';
import { MapJsonReader2b7ri7r44421y as MapJsonReader } from './MapJsonReader.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readAny(_this__u8e3s4) {
  var token = _this__u8e3s4.s3z();
  var tmp;
  switch (token.b2_1) {
    case 9:
      tmp = _this__u8e3s4.l49();
      break;
    case 8:
      tmp = _this__u8e3s4.ho();
      break;
    case 7:
    case 6:
      tmp = guessNumber(_this__u8e3s4);
      break;
    case 5:
      tmp = _this__u8e3s4.z40();
      break;
    case 2:
      _this__u8e3s4.p40();
      // Inline function 'kotlin.collections.mutableMapOf' call

      var result = LinkedHashMap().gc();
      while (_this__u8e3s4.v1()) {
        result.c5(_this__u8e3s4.r40(), readAny(_this__u8e3s4));
      }

      _this__u8e3s4.q40();
      tmp = result;
      break;
    case 0:
      _this__u8e3s4.u40();
      // Inline function 'kotlin.collections.mutableListOf' call

      var result_0 = ArrayList().u2();
      while (_this__u8e3s4.v1()) {
        result_0.n2(readAny(_this__u8e3s4));
      }

      _this__u8e3s4.v40();
      tmp = result_0;
      break;
    default:
      var message = 'unknown token ' + token.toString();
      throw IllegalStateException().o(toString(message));
  }
  return tmp;
}
function guessNumber(_this__u8e3s4) {
  try {
    return _this__u8e3s4.sk();
  } catch ($p) {
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3 = $p;
    } else {
      throw $p;
    }
  }
  try {
    return _this__u8e3s4.eo();
  } catch ($p) {
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3_0 = $p;
    } else {
      throw $p;
    }
  }
  try {
    return _this__u8e3s4.e41();
  } catch ($p) {
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3_1 = $p;
    } else {
      throw $p;
    }
  }
  return _this__u8e3s4.f4c();
}
function jsonReader(_this__u8e3s4) {
  return new (BufferedSourceJsonReader())(_this__u8e3s4);
}
function jsonReader_0(_this__u8e3s4) {
  return new (MapJsonReader())(_this__u8e3s4);
}
//region block: exports
export {
  jsonReader as jsonReaderkr2c3w0efm9b,
  jsonReader_0 as jsonReader2agwreccj3lmk,
  readAny as readAny17j2jqaxubdko,
};
//endregion

//# sourceMappingURL=JsonReaders.mjs.map
